// Тактильный отклик слота (вибрация). Все узоры здесь, точки вызова — рядом со звуком (sfx) в slot-game.js.
// api = { impact(style), notify(type), selection() } из opts.haptic; нет api — все методы молча ничего не делают.
// isQuiet() — автоигра/турбо: остаются только значимые события (скаттеры, выигрыш от ×5, бонуска, ошибки).
// isActive() — false после destroy: запланированные удары не срабатывают.

export function createHaptic(api, isQuiet, isActive) {
  const timers = new Set();
  let runTimer = 0, last = 0;

  const call = (fn, arg) => {
    if (!api || !isActive() || typeof api[fn] !== 'function') return;
    try { api[fn](arg); } catch (e) { /* вибрация не критична */ }
  };
  const impact = style => call('impact', style);
  const notify = type => call('notify', type);
  // Частые одиночные удары не чаще раза в 45 мс — иначе Telegram их склеивает
  const throttled = fn => { const now = Date.now(); if (now - last < 45) return; last = now; fn(); };
  const later = (ms, fn) => { const id = setTimeout(() => { timers.delete(id); fn(); }, ms); timers.add(id); };
  // Серия ударов: [задержка, стиль] или [задержка, 'success' | 'error' | 'warning']
  const pattern = steps => steps.forEach(([ms, kind]) => later(ms, () => (['success', 'error', 'warning'].includes(kind) ? notify(kind) : impact(kind))));

  // Остановить ритм и все запланированные удары (пропуск анимации, закрытие оверлея, уход с экрана)
  function stop() { clearTimeout(runTimer); runTimer = 0; timers.forEach(clearTimeout); timers.clear(); }
  // Ритм на ms миллисекунд: интервал плавно меняется от `from` до `to` (ожидание скаттера, рост суммы)
  function run(ms, from, to, style) {
    clearTimeout(runTimer);
    const t0 = Date.now();
    (function tick() {
      const k = (Date.now() - t0) / ms;
      if (k >= 1 || !isActive()) { runTimer = 0; return; }
      impact(style);
      runTimer = setTimeout(tick, from + (to - from) * k);
    })();
  }

  return {
    // Кнопки — действие игрока, вибрируют всегда
    tap: (style = 'light') => impact(style),
    select: () => throttled(() => call('selection')),
    edge: () => notify('warning'),
    // Поле остановилось (последний барабан без скаттера)
    reelsDone: () => { if (!isQuiet()) impact('soft'); },
    // Скаттер упал: первый — средний, второй и дальше — сильный
    scatter: n => { stop(); impact(n >= 2 ? 'heavy' : 'medium'); },
    // Ожидание третьего скаттера: учащающиеся лёгкие удары, пока крутится подсвеченный барабан
    antic: ms => run(ms, 190, 70, 'light'),
    // Обычный выигрыш по размеру в ставках (крупные ×15+ — big)
    win: x => {
      if (x >= 5) pattern([[0, 'success'], [130, 'medium']]);
      else if (isQuiet()) return;
      else if (x >= 1) notify('success');
      else impact('light');
    },
    // BIG / MEGA / EPIC (level 1–3): 2/3/4 сильных удара, затем лёгкий ритм, пока растёт сумма
    big: (level, countMs) => {
      const n = level + 1, gap = 140;
      pattern(Array.from({ length: n }, (_, i) => [i * gap, 'heavy']));
      later(n * gap + 60, () => run(Math.max(0, countMs - n * gap), 90, 160, 'light'));
    },
    bonus: () => pattern([[0, 'heavy'], [160, 'heavy'], [380, 'success']]),
    // Трещотка колеса фриспинов — на каждой дольке под указателем
    tick: () => throttled(() => call('selection')),
    wheelWin: () => pattern([[0, 'heavy'], [170, 'success']]),
    // Старт очередного фриспина
    step: () => { if (!isQuiet()) impact('light'); },
    error: () => notify('error'),
    warn: () => notify('warning'),
    stop,
  };
}
